<span
  class="fa-stack fa-2x scroll-to-top"
  [ngClass]="{ 'show-scroll': showScroll }"
  (click)="scrollToTop()"
>
  <i class="fas fa-circle fa-stack-2x"></i>
  <i class="fas fa-chevron-up fa-stack-1x fa-inverse"></i>
</span>
